module.exports = __webpack_public_path__ + "static/media/Trading_Up_Mobile_Banner_STAKE@2x.da6019e1.webp";